module.exports = __webpack_public_path__ + "media/bootstrap-icons/bar-chart-steps-c9da1610.svg";